module.exports = __webpack_public_path__ + "images/athlon_smallf0326be83df1cfdcf43e7071d2ca5e8d.png";